import { Box } from '@mui/material'
import React from 'react'
import { useQuery } from 'react-query'
import { banks, salaryCategories } from 'services/api/dropdown'
import { getBankData } from 'services/api/modules/staff-management/staffManagementDashboard'
import SalaryDetails from './SalaryDetails'
import StatutoryBodyDetails from './StatutoryBodyDetails'

const BankStatutoryDetails = ({ employeeId, time_id }) => {
  const { data: bank } = useQuery(['employeeBankData', employeeId], async () => {
    const { data } = await getBankData(employeeId)
    return data
  })

  const { data: salCat } = useQuery('salaryCategories', async () => {
    const { data } = await salaryCategories()
    return data
  })
  const { data: bankDropdown } = useQuery('bankCategories', async () => {
    const { data } = await banks()
    return data
  })

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box sx={{ border: 1, borderColor: 'gray-line.main', borderRadius: '4.5px' }}>
        <SalaryDetails
          employeeId={employeeId}
          data={bank}
          salCat={salCat}
          bankDropdown={bankDropdown}
          time_id={time_id}
        />
      </Box>
      <Box sx={{ border: 1, borderColor: 'gray-line.main', borderRadius: '4.5px' }}>
        <StatutoryBodyDetails data={bank} employeeId={employeeId} time_id={time_id} />
      </Box>
    </Box>
  )
}

export default BankStatutoryDetails
